export const skills = [
  {
    id: 1,
    title: "HTML",
  },
  {
    id: 2,
    title: "CSS",
  },
  {
    id: 3,
    title: "Javascript",
  },
  {
    id: 4,
    title: "Bootstrap",
  },
  {
    id: 5,
    title: "React.js",
  },
  {
    id: 18,
    title: "Unit Testing",
  },
  {
    id: 19,
    title: "Jest",
  },
  {
    id: 8,
    title: "React-Redux",
  },
  {
    id: 15,
    title: "Typescript",
  },
  {
    id: 16,
    title: "React Native",
  },
  {
    id: 9,
    title: "React-Router",
  },
  {
    id: 10,
    title: "RESTful API's",
  },
  {
    id: 11,
    title: "Material-UI",
  },
  {
    id: 12,
    title: "Tailwind CSS",
  },
  {
    id: 6,
    title: "Github",
  },
  {
    id: 7,
    title: "Responsive Design",
  },
  {
    id: 13,
    title: "Code Splitting",
  },
  {
    id: 14,
    title: "State and Props Mangement",
  },

  {
    id: 17,
    title: "Performance Optimization",
  },
];
